import CryptoJS from 'crypto-js'

export function isObj(value) {
  return value && Object.prototype.toString.call(value) === '[object Object]'
}

export function isString(value) {
  return value && Object.prototype.toString.call(value) === '[object String]'
}

export function isArray(value) {
  return value && Object.prototype.toString.call(value) === '[object Array]'
}

export function stringToJson(str) {
  if (isJsonString(str)) {
    try {
      return JSON.parse(str)
    } catch (e) {
      // window.console.log(e)
    }
  }
  return str
}

export function isJsonString(str) {
  if (isString(str)) {
    try {
      str = JSON.parse(str)
      if (isObj(str) || isArray(str)) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  }
  return false
}


// 根据设备品牌解析对应的市场来源
export function parseMarketSource(brand) {
  // OPPO系品牌列表
  const BRAND_OPPO = 'OPPO'
  const BRAND_ONEPLUS = 'OnePlus'
  const BRAND_REALME = 'realme'

  // 小米品牌
  const BRAND_XIAOMI = 'Xiaomi'

  // 传音系品牌列表
  const BRAND_TECNO = 'Tecno'
  const BRAND_INFINIX = 'Infinix'
  const BRAND_ITEL = 'itel'

  // 统一转为小写处理，避免大小写差异导致的判断问题
  const brandLower = brand ? brand.toLowerCase() : ''

  // OPPO系品牌判断
  if (BRAND_OPPO.toLowerCase() === brandLower || BRAND_ONEPLUS.toLowerCase() === brandLower || BRAND_REALME.toLowerCase() === brandLower) {
    return 'OPPO'
  }

  // 传音系品牌判断
  if (BRAND_TECNO.toLowerCase() === brandLower || BRAND_INFINIX.toLowerCase() === brandLower || BRAND_ITEL.toLowerCase() === brandLower) {
    return 'TRANSSION'
  }

  // 小米品牌判断
  if (BRAND_XIAOMI.toLowerCase() === brandLower) {
    return 'MI'
  }

  return 'Unknown'
}

// 生成至少32字符的随机字符串 (a-z, A-Z, 0-9, _, -)
export const generateState = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-'
  let state = ''
  const randomArray = new Uint8Array() // 生成32字节的随机值更安全
  crypto.getRandomValues(randomArray)
  for (let i = 0; i < randomArray.length; i++) {
    // 确保索引在 chars 范围内
    state += chars[randomArray[i] % chars.length]
  }
  // 确保长度至少为32，如果不足则追加（理论上不会，但确保安全）
  while (state.length < 32) {
    state += chars[Math.floor(Math.random() * chars.length)]
  }
  // 存储state，用于回调时验证
  sessionStorage.setItem('vk_oauth_state', state)
  return state
}


// 生成随机 state 的函数示例
export function generateRandomState(length) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

// 生成 code_verifier 的函数示例
export function generateCodeVerifier() {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
  let codeVerifier = '';
  for (let i = 0; i < Math.floor(Math.random() * (128 - 43 + 1)) + 43; i++) {
    codeVerifier += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return codeVerifier;
}

// 将 code_verifier 转换为 code_challenge 的函数示例（使用 crypto 模块，仅适用于支持的环境）
// export async function generateCodeChallenge(codeVerifier) {
//   const encoder = new TextEncoder();
//   const data = encoder.encode(codeVerifier);
//   const hash = await window.crypto.subtle.digest('SHA256', data);
//   return btoa(String.fromCharCode(...new Uint8Array(hash)))
//    .replace(/\+/g, '-')
//    .replace(/\//g, '_')
//    .replace(/=/g, '');
// }

export async function generateCodeChallenge(codeVerifier) {
  // 使用 crypto-js 计算 SHA-256 哈希
  const hash = CryptoJS.SHA256(codeVerifier);
  // 将 WordArray 转换为 Base64Url 字符串
  return hash.toString(CryptoJS.enc.Base64)
           .replace(/\+/g, '-')
           .replace(/\//g, '_')
           .replace(/=/g, '');
}

/**
 * 判断 forceLoginTime 是否为今天
 * @param {number} compareTime - 时间戳
 * @returns {boolean} 是否为今天
 */
export function isToday(compareTime) {
  try {
    const targetDate = new Date(Number(compareTime));
    const today = new Date();
    // 对比年、月、日
    return (
        targetDate.getFullYear() === today.getFullYear() &&
        targetDate.getMonth() === today.getMonth() &&
        targetDate.getDate() === today.getDate()
    );
  } catch (e) {
    // 传入的时间不是时间戳格式
  }
  return false;
}